import axios from "axios";

const store = {
  state: {
    users: [],
  },

  getters: {
    getUsersAdmin(state) {
      return state.users;
    },
  },

  mutations: {
    loadUsers(state, users) {
      state.users = users;
    },

    addUser(state, user) {
      state.users.push(user);
    },

    editUser(state, user) {
      let userIndex = state.users.findIndex((u) => u.id == user.id);
      state.users[userIndex].phone = user.phone;
      state.users[userIndex].email = user.email;
      state.users[userIndex].full_name = user.full_name;
      state.users[userIndex].sex = user.sex;
    },
  },

  actions: {
    indexUsersAction({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/account/admin`)
          .then((res) => {
            commit("loadUsers", res.data);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    registerUserAction({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/account/store-admin`, payload)
          .then((res) => {
            commit("addUser", res.data.user);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    editUserAction({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/account/update-admin/${payload.id}`, payload)
          .then((res) => {
            commit("editUser", res.data.user);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    //busca todos los usuarios super admin
    findUsersSuperAction(Context, business_id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/account/find/super/${business_id}`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};

export default store;
